export const getters = {
    getUnidadeMedida: state => state.unidadeMedida,
    getUnidadesMedidas: state => state.unidadesMedidas,
    getModalCadastroUnidadeMedida: state => state.modalCadastrarUnidadesMedida,
    getModalExcluirUnidadeMedida: state => state.modalExcluirUnidadeMedida,
    getModalPesquisarUnidadeMedida: state => state.modalPesquisarUnidadeMedida
}

export default {}